import { render, staticRenderFns } from "./MsTabs.vue?vue&type=template&id=06f7026c&scoped=true"
import script from "./MsTabs.vue?vue&type=script&lang=js"
export * from "./MsTabs.vue?vue&type=script&lang=js"
import style0 from "./MsTabs.vue?vue&type=style&index=0&id=06f7026c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7026c",
  null
  
)

export default component.exports